var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffe70d",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,2c-12.703,0 -23,10.297 -23,23c0,12.703 10.297,23 23,23c12.703,0 23,-10.297 23,-23c0,-12.703 -10.297,-23 -23,-23zM25.34,32.413c2.527,0 4.451,-1.295 5.03,-3.395h2.301c-0.604,3.332 -3.471,5.482 -7.331,5.482c-4.929,0 -8.01,-3.647 -8.01,-9.494c0,-5.86 3.068,-9.506 7.997,-9.506c3.823,0 6.803,2.402 7.343,5.897h-2.301c-0.604,-2.339 -2.54,-3.81 -5.042,-3.81c-3.483,0 -5.671,2.867 -5.671,7.419c0,4.552 2.188,7.407 5.684,7.407z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsIcon);
export default __webpack_public_path__ + "static/media/points-icon.061ab31852aa686ff5e207ae53ec686f.svg";
export { ForwardRef as ReactComponent };